
    import '/opt/buildhome/repo/docs/react/model-use-other.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/docs/react/model-use-other.en-US.md?type=demo')
};